/* eslint no-use-before-define: 0 */

import axios from 'axios';

export default axios;
